import { render, staticRenderFns } from "./Maintabbar.vue?vue&type=template&id=c87f9ff6&scoped=true&"
import script from "./Maintabbar.vue?vue&type=script&lang=js&"
export * from "./Maintabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87f9ff6",
  null
  
)

export default component.exports